import styled from 'styled-components';

const MediaStyles = styled.div``;

export default MediaStyles;
